export default "__VITE_ASSET__BZc$iduM__"